import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth, db } from '../../services/firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import './AdminLayout.css';
import '../../pages/admin/AdminFlagsPage.css';

const ADMIN_TABS = [
  { path: '/admin',                 label: 'Games',          icon: '🏟',  exact: true  },
  { path: '/admin/setup',           label: 'Setup',          icon: '⚙️',  exact: false },
  { path: '/admin/schedule',        label: 'Schedule',       icon: '📅',  exact: false },
  { path: '/admin/odds',            label: 'Runners & Odds', icon: '💲',  exact: false },
  { path: '/admin/scratchings',     label: 'Scratchings',    icon: '🚫',  exact: false },
  { path: '/admin/results',         label: 'Results',        icon: '✓',   exact: false },
  { path: '/admin/leaderboard',     label: 'Leaderboard',    icon: '🏆',  exact: false },
  { path: '/admin/leagues',         label: 'Leagues',        icon: '🎖️',  exact: false },
  { path: '/admin/users',           label: 'Users',          icon: '👤',  exact: false },
  { path: '/admin/announcements',   label: 'Announcements',  icon: '📢',  exact: false },
];

export const AdminLayout = ({ children }) => {
  const location   = useLocation();
  const navigate   = useNavigate();
  const slateParam = new URLSearchParams(location.search).get('slate') || '';
  const [flagCount, setFlagCount] = useState(0);

  useEffect(() => {
    const q = query(
      collection(db, 'admin_flags'),
      where('status', '==', 'pending')
    );
    return onSnapshot(q, snap => setFlagCount(snap.size), () => {});
  }, []);

  async function handleAdminLogout() {
    try {
      await signOut(auth);
      navigate('/signin');
    } catch (err) {
      console.error('Logout failed:', err);
      alert('Logout failed — please try again.');
    }
  }

  const isActive = (tab) => {
    if (tab.exact) return location.pathname === tab.path;
    return location.pathname.startsWith(tab.path);
  };

  const tabHref = (tabPath) => slateParam ? `${tabPath}?slate=${slateParam}` : tabPath;

  return (
    <div className="ss-admin-layout">
      <div className="ss-admin-layout__header">
        <Link to="/admin" className="ss-admin-layout__logo">
          <span className="ss-admin-layout__logo-wordmark">SYNDICATOR<span>SHOWDOWN</span></span>
          <span className="ss-admin-layout__badge">ADMIN</span>
        </Link>
        <div className="ss-admin-layout__header-spacer" />
        <div className="ss-admin-layout__header-actions">
          <button
            className="ss-admin-layout__logout-btn"
            onClick={handleAdminLogout}
            type="button"
          >
            Logout
          </button>
          <Link to="/" className="ss-admin-layout__back-link">← Back to site</Link>
        </div>
      </div>

      <nav className="ss-admin-layout__nav">
        {ADMIN_TABS.map(tab => (
          <Link key={tab.path} to={tabHref(tab.path)} className={`ss-admin-layout__nav-item ${isActive(tab) ? 'ss-admin-layout__nav-item--active' : ''}`}>
            <span className="ss-admin-layout__nav-icon">{tab.icon}</span>
            <span>{tab.label}</span>
          </Link>
        ))}
        <Link
          to={tabHref('/admin/flags')}
          className={`ss-admin-layout__nav-item ${location.pathname.startsWith('/admin/flags') ? 'ss-admin-layout__nav-item--active' : ''}`}
        >
          <span className="ss-admin-layout__nav-icon">🚩</span>
          <span>
            Safety
            {flagCount > 0 && (
              <span className="admin-nav__badge">{flagCount}</span>
            )}
          </span>
        </Link>
      </nav>

      <main className="ss-admin-layout__content">{children}</main>
    </div>
  );
};

export default AdminLayout;